<template>
  <div>
    <img-mask
      @close="shareToast = false"
      :open="shareToast"
      :commitFlag="toastFlag"
      :opacity="0.5"
      class="shareImg-box"
    >
      <div slot="imgContent" class="shareImg-top">
        <img
          class="share-tip-img"
          :src="maskType === 'friend' ? shareImgToFriend : wxshareImg"
          alt=""
        />
      </div>
    </img-mask>
  </div>
</template>

<script>
import xDialog from "@/components/Popup/x-dialog";
import wxshareImg from "@/assets/img/shareImg.png";
import shareImgToFriend from "@/assets/img/shareImgToFriend.png";
import imgMask from "@/components/feedback/imgMask";
import wx from "@/utils/jweixin-1.3.2";
import ApplyMethods from "@/utils/applyMethods.js";
export default {
  name: "Login",
  components: { xDialog, imgMask },
  data() {
    return {
      shareToast: false,
      wxshareImg,
      shareImgToFriend,
      toastFlag: true,
      shareTimelineData: {},
      shareAppMessageData: {},
      wxRedy: null
    };
  },
  props: {},
  created() {
    const envconfig = this.$utils.isWX_QQ_web();
    this.isWx = envconfig === "weixin" || envconfig === "QQ";
  },
  mounted() {
    this.wxRedy = new ApplyMethods(this).wxRedy;
    if (this.isWx) {
      this.init();
      this.share();
    } else {
      this.shareMiniapp();
    }
  },
  watch: {},
  methods: {
    init() {
      this.shareTimelineData = {
        title: this.title,
        link: this.link,
        imgUrl: this.shareImg,
        success: () => {
          this.shareToast = false;
        },
        cancel: () => {
          this.shareToast = false;
        }
      };
      this.shareAppMessageData = {
        title: this.title,
        link: this.link,
        imgUrl: this.shareImg,
        desc: this.desc, // 分享描述
        dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
        success: () => {
          this.shareToast = false;
        },
        cancel: () => {
          this.shareToast = false;
        }
      };
      this.wxRedy();
      console.log("shareTimelineData_________");
      console.log(this.shareTimelineData);
      if (this.$utils.getUrlParam("isMiniProgram")) {
        uni.postMessage({
          data: {
            title: this.title,
            path: "/page/index/index",
            imageUrl: this.shareImg
          }
        });
      }
    },
    async share() {
      // 判断在什么环境下 微信还是QQ还是自带浏览器
      const envconfig = this.$utils.isWX_QQ_web();
      if (envconfig === "weixin" || envconfig === "QQ") {
        this.shareTimelineData.link = this.link;
        this.shareTimelineData.title = this.title;
        this.shareAppMessageData.link = this.link;
        this.shareAppMessageData.title = this.title;
        this.shareToast = true;
      } else {
        // 调原生
        this.jsbridge.call("sharingComponents", {
          title: this.title,
          contentInfo: this.desc,
          imageUrl: this.shareImg,
          linkUrl: this.link
        });
      }
    },
    // 分享小程序
    shareMiniapp() {
      const version = this.$utils.getUrlParam("version");
      if (this.isWx) {
        this.shareToast = true;
        wx.miniProgram.navigateTo({
          url: this.link
        });
      } else if (version) {
        this.jsbridge.call("miniprogramShare", {
          miniprogramUrl: this.link,
          miniprogramImage: this.shareImg,
          miniprogramMsg: this.desc,
          // miniprogramAppid: 'gh_12cbd5b8d4fe', // 活动小程序
          miniprogramAppid: this.isXXCD ? "gh_0fa1541a5849" : "gh_12cbd5b8d4fe", // xx小程序
          miniprogramH5: "www.baidu.com"
        });
      } else {
        this.shareToast = true;
      }
    }
  }
};
</script>

<style>
.shareImg-box .meswrap {
  position: absolute !important;
  top: 0rem !important;
  right: 1.2rem;
}
.share-tip-img {
  width: 440px;
  height: 391px;
}
</style>



// WEBPACK FOOTER //
// src/starcharge/plugin/share/share.vue